import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss']
})
export class ThanksComponent implements OnInit {
  @HostBinding('class') hostClasses = 'hero is-medium';
  title: string;
  message: string;

  constructor(private router: Router, private titleService: Title) { }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url === '/gracias') {
          this.title = '¡Gracias!';
          this.titleService.setTitle('Gracias - CCCISA');
          this.message = 'Hemos recibido tu mensaje y en breve nos comunicaremos contigo.';
        } else {
          this.title = '¡Oh no!';
          this.titleService.setTitle('Error - CCCISA');
          this.message = 'Ocurrió un error inesperado.';
        }
      }
    });
  }
}
